import React, { useEffect } from 'react';
import './Home.css';
import backgroundVideo from './assets/background.mp4';

const Home = () => {
  useEffect(() => {
    const videoElement = document.querySelector('video');
    videoElement.play();
  }, []);

  return (
    <section className="container">
      <div className="video__container">
        <video src={backgroundVideo} className="video" muted loop></video>
      </div>
      <div className="container__items">
        <h1 className="container__title">
          Hola, Somos Elium<span>Nova</span>
        </h1>
        <h4 className="container__description">
          Transformamos ideas en experiencias digitales excepcionales. creando
          interfaces de usuario hermosas y aplicaciones web potentes, diseñadas
          para crecer con tu negocio. <br />
          <br />
          Innovamos en cada proyecto, ofreciendo soluciones ágiles y de alto
          rendimiento que destacan por su calidad y diseño. <br />
          <br />
          ¡Hace realidad tu visión digital!
        </h4>
        <div className="container__buttons">
          <a href="/" className="btn__plus text__a-modificated">
            Conoce Más
          </a>
          <a href="/" className="btn__contact text__a-modificated">
            Contactanos
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
